<template>
   <div>
      <form v-if="!isSuccess" class="enquiry-form" name="internship-form"> 
        <div class="form-group">
            <input type="text" id="name1"  name="name" placeholder="Name*" v-model="userDetails.name" v-validate="{ rules: { required: true } }" required>
            <span class="text-danger" v-show="errors.has('name')">
              <small>Name should be valid</small>
            </span>
        </div>
        <div class="form-group">
            <input type="email" id="email1" name="emailId" placeholder="Email*" v-model="userDetails.emailId" required>
        </div>
        <div class="form-group">
            <div class="input-group">
                <span class="input-group-addon" id="basic-addon1">+ 91</span>
                <input type="text" placeholder="Mobile Number" aria-describedby="basic-addon1" v-model="userDetails.mobileNo" inputmode="numeric" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" pattern="^[6-9]\d{9}$" minlength="10" maxlength="10" name="mobileNo" >
                <span class="text-danger" v-show="errors.has('mobileNo')">
              <small>Mobile Number should be valid</small>
            </span>
            </div>
        </div>
        <div class="form-group">
            <input type="text" id="topic1" name="reason" placeholder="Reason/ Topic*" required v-model="userDetails.reason">
        </div>
        <div class="form-group">
            <input type="text" id="duration1" name="duration" placeholder="Duration*" required v-model="userDetails.duration">
        </div>
        <div class="form-group ">
            <label>
              <span class="fa fa-paperclip" id="basic-addon2"></span> <input class="file-group" id="file-icon" type="file" name="file" @change="onFileSelected" placeholder="Attach your CV/Resume in PDF or Word document format" accept=".pdf,.doc,.docx">
              <span id="file-chosen">No file chosen</span>
            </label>
        </div>
        <span style="color:red;" v-if="showFileSizeError"><small>File size should be less than 2 MB</small></span>
        <div class="button-holder">
            <button type="button" name="submit-form" class="theme-btn btn-style-two" :disabled="isSubmitDisabled" @click="validateInput">{{btnLabel}}</button>
        </div>
      </form>
      <div v-if="isSuccess" class="success-blog">
        <h3 class="enquiry-success">Thanks for showing interest in working with us! <span> Your request is submitted successfully to NIRMAN team, you can expect reply within 7 days </span></h3>
      </div> 
   </div>
</template>

<script>
import axios from 'axios'
export default {
name:'internshipData',
  components: {
  },
  data() {
    return {
      userDetails: {
        name: '',
        mobileNo: '',
        emailId: '',
        reason: '',
        duration: '',
        file: '',
        filePath: ''
      },
      isFileUploaded: false,
      isSuccess: false,
      btnLabel: 'submit',
      isSubmitDisabled: false,
      showFileSizeError: false
    }
  },
  methods: {
    onFileSelected (e) {
      // console.log(e.target.files);
      if (!e.target.files.length) {
        return;
      }
      if (e.target.files[0].size > 2097152) {
        this.showFileSizeError = true
        return
      } else {
        this.showFileSizeError = false
      }
      console.log(e.target.files[0]);
      this.userDetails.file = e.target.files[0]
    },
    validateInput () {
      // console.log('validateInput called');
      if (!this.userDetails.name) {
        this.$toasted.error('Please enter valid name')
        return false;
      }
      if (!this.userDetails.emailId) {
        this.$toasted.error('Please enter valid emailId')
        return false;
      }
      if (!this.userDetails.reason) {
        this.$toasted.error('Please enter valid reason')
        return false;
      }
      if (!this.userDetails.duration) {
        this.$toasted.error('Please enter valid duration')
        return false;
      }
      this.$validator.validateAll()
      if (!this.errors.any()) {
        if (this.userDetails.file !== '') {
          // console.log('inside if');
          var fileFormData = new FormData()
          fileFormData.append('file', this.userDetails.file)
          return new Promise((resolve, reject) => {
            // console.log('calling upload');
            this.btnLabel = 'Uploading Document...'
            this.isSubmitDisabled = true
            axios.post('/o/uploadFile', fileFormData).then(response => {
              if (response.status === 200 && response.data !== '') {
                this.isFileUploaded = true
                this.userDetails.filePath = response.data
                // console.log('this.userDetails.filePath:::', this.userDetails.filePath)
                
                this.saveEnquiryDetails().then(res => {}).catch(err => {console.log(err)})
              }
            }).catch(err => {
              console.log(err)
              this.$toasted.error('Error occured while uploading file...')
              this.isSubmitDisabled = false
              this.btnLabel = 'Submit'
              reject(err)
            })
          })
        } else {
          this.saveEnquiryDetails().then(res => {}).catch(err => {console.log(err)})
        }
      } else {
        this.$toasted.error('Please provide valid details...')
        return
      }
    },
    saveEnquiryDetails() {
      this.isSubmitDisabled = true
      this.btnLabel = 'Saving Data...'
      return new Promise((resolve, reject) => {
          axios.post('/o/saveEnquiryDetails', this.userDetails).then((result) => 
          {
            if (result.status === 200 && result.data === true) {
            //  this.$toasted.success('Request sent to our team...', {
            //       'duration': 3000
            //     })
            this.isSuccess = true
            this.isSubmitDisabled = false
            this.btnLabel = 'Submit'
              resolve(true)
            }
          }).catch((err) => {
            console.log(err)
            this.$toasted.error('Error occured while saving data...')
            this.isSubmitDisabled = false
            this.btnLabel = 'Submit'
            reject(err)
          });
        })
    }
    /* validateInput () {
      this.$validator.validateAll()
      if (this.errors.any()) {
        return false
      }
      return true
    } */
    
  },
   created: function () {
  },
   mounted: function () {
     // For Capturing File Name
    const fileIcon = document.getElementById('file-icon');

    const fileChosen = document.getElementById('file-chosen');

    fileIcon.addEventListener('change', function(){
      fileChosen.textContent = this.files[0].name
    })
  }
}
</script>

 


// WEBPACK FOOTER //
// internshipData.vue?13ed2519